// packages/supabase-client/src/client.ts (REVISED & SIMPLIFIED)

import { createClient, SupabaseClient } from '@supabase/supabase-js';

export const initSupabase = (supabaseUrl: string, supabaseAnonKey: string): SupabaseClient => {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase URL and Anon Key are required for initialization.');
  }
  
  const supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  
  console.log('@dopomogai/supabase-client: Supabase client initialized.');
  return supabaseInstance;
};